import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "./components/Auth/Login";
import Signup from "./components/Auth/Signup";
import Navbar from "./components/Navbar";
import ProtectedRoute from "./components/ProtectedRoute";
import AccessDenied from "./components/Auth/AccessDenied";
import Admin from "./components/AuditLogs/Admin";
import UserProfile from "./components/Auth/UserProfile";
import ForgotPassword from "./components/Auth/ForgotPassword";
import OAuth2RedirectHandler from "./components/Auth/OAuth2RedirectHandler";
import { Toaster } from "react-hot-toast";
import NotFound from "./components/NotFound";
import ContactPage from "./components/contactPage/ContactPage";
import AboutPage from "./components/aboutPage/AboutPage";
import ResetPassword from "./components/Auth/ResetPassword";
import Footer from "./components/Footer/Footer";
import LandingPage1 from "./components/LandingPage/LandingPage1";
import Booking from "./components/Booking/Booking";
import MyBookings from "./components/Booking/MyBookings";
import AllBookings from "./components/Booking/AllBookings";
import PrivacyPolicy from "./components/privacyPage/PrivacyPolicy";
import Disclaimer from "./components/Disclaimer/Disclaimer";
import TermsAndConditions from "./components/Terms/TermsAndConditions";
import Review from "./components/Review/Review";
import ReviewList from "./components/Review/ReviewList";
import WashReport from "./components/Report/WashReport";
import WashSummaryReport from "./components/Report/WashSummaryReport";
import WashByPartnerReport from "./components/Report/WashByPartnerReport";
import PartnerEarningSummaryReport from "./components/Report/PartnerEarningSummaryReport";
import EarningByPartnerReport from "./components/Report/EarningByPartnerReport";

const App = () => {
  return (
    <Router>
      <Navbar />
      <div className="pb-20">
        <Toaster position="bottom-center" reverseOrder={false} />
        <Routes>
          {/* <Route path="/" element={<LandingPage />} /> */}
          <Route path="/" element={<LandingPage1 />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route
            path="wash-by-partner/:partnerId/:year/:month"
            element={
              <ProtectedRoute adminAndWorkerPage={true}>
                <WashByPartnerReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="earning-by-partner/:partnerId/:year/:month"
            element={
              <ProtectedRoute adminAndWorkerPage={true}>
                <EarningByPartnerReport />
              </ProtectedRoute>
            }
          />
          {/* <Route path="/reviews" element={<Review />} /> */}

          <Route
            path="/wash-summary-report"
            element={
              <ProtectedRoute adminAndWorkerPage={true}>
                <WashSummaryReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/earning-summary-report"
            element={
              <ProtectedRoute adminAndWorkerPage={true}>
                <PartnerEarningSummaryReport />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reviews"
            element={
              <ProtectedRoute>
                <Review />
              </ProtectedRoute>
            }
          />
          <Route
            path="/review-list"
            element={
              <ProtectedRoute adminPage={true}>
                <ReviewList />
              </ProtectedRoute>
            }
          />

          <Route
            path="/create-booking"
            element={
              <ProtectedRoute>
                <Booking />
              </ProtectedRoute>
            }
          />

          <Route
            path="/my-bookings"
            element={
              <ProtectedRoute>
                <MyBookings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/all-bookings"
            element={
              <ProtectedRoute adminPage={true}>
                <AllBookings />
              </ProtectedRoute>
            }
          />

          <Route path="/access-denied" element={<AccessDenied />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute adminPage={true}>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <UserProfile />
              </ProtectedRoute>
            }
          />
          <Route path="/oauth2/redirect" element={<OAuth2RedirectHandler />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </Router>
  );
};

export default App;
